import { createContext, ReactNode, useContext, useMemo } from 'react'
import { useLoadSessionExpiresAt } from './hooks/use-load-session-expires-at'

interface SessionExpiresAtContextValue {
  sessionExpiresAt?: number
}

const SessionExpiresAtContext =
  createContext<SessionExpiresAtContextValue | null>(null)

interface Props {
  children: ReactNode
}

// The session guard and the topbar countdown share one loaded expiry
export const SessionExpiresAtProvider = ({ children }: Props) => {
  const sessionExpiresAt = useLoadSessionExpiresAt()
  const value = useMemo(() => ({ sessionExpiresAt }), [sessionExpiresAt])

  return (
    <SessionExpiresAtContext.Provider value={value}>
      {children}
    </SessionExpiresAtContext.Provider>
  )
}

// Undefined until the auth time is read from the token
export const useSessionExpiresAt = () => {
  const context = useContext(SessionExpiresAtContext)

  if (!context) {
    throw new Error(
      'useSessionExpiresAt must be used inside SessionExpiresAtProvider'
    )
  }

  return context.sessionExpiresAt
}
